import React, { PureComponent } from 'react';

import ModalContainer from '../../../../../components/shared/modal/ModalContainer';
import { PrimaryButton, StyledRow } from '../../../../../components/shared/sharedStyles.styles';
import { Container, SpanTitle, GrayText } from '../../../request/form/fieldModal/formModalFields.styled';
import LoadingCircle from '../../../../../components/shared/treatedIcons/LoadingCircle';

class ModalReportWhatsapp extends PureComponent {
  renderFooter = () => {
    const { loading, sending, preview } = this.props;

    if (loading) {
      return null;
    }

    return (
      <StyledRow padding="0 3em" justify="space-around">
        <PrimaryButton
          onClick={this.props.onClose}
          disabled={sending}
          customStyle="&:disabled { cursor: no-drop; }"
        >
          {preview && preview.pode_enviar ? 'Cancelar' : 'Fechar'}
        </PrimaryButton>
        {preview && preview.pode_enviar ? (
          <PrimaryButton
            onClick={this.props.onConfirm}
            disabled={sending}
            customStyle="&:disabled { cursor: no-drop; }"
          >
            {sending ? 'Enviando…' : 'Confirmar envio'}
          </PrimaryButton>
        ) : null}
      </StyledRow>
    );
  };

  renderHeader = () => (
    <SpanTitle customstyle="margin: auto;">
      ENVIAR LAUDO PELO WHATSAPP
    </SpanTitle>
  );

  renderBody = () => {
    const { preview, loading, solicitacaoId } = this.props;

    if (loading) {
      return null;
    }

    if (!preview) {
      return 'Não foi possível carregar o destinatário.';
    }

    if (!preview.pode_enviar) {
      return (
        <p>
          {preview.message || 'Não há telefone WhatsApp cadastrado para envio.'}
        </p>
      );
    }

    return (
      <p>
        {preview.mensagem_envio || (
          <>
            O PDF (laudo) da solicitação #{solicitacaoId} será enviado para:
          </>
        )}
        <br />
        <br />
        <strong style={{ fontSize: '1.1rem' }}>{preview.to_formatado || preview.to}</strong>
        <br />
        <br />
        <span style={{ fontSize: '0.85rem' }}>{preview.fonte_label}</span>
      </p>
    );
  };

  renderLoading = () => {
    if (this.props.loading || this.props.sending) {
      return (
        <div style={{ marginTop: 20, marginBottom: -10 }}>
          <LoadingCircle width="30px" height="30px" margin="0 auto" color="color_border-gray" />
        </div>
      );
    }

    return null;
  };

  render() {
    return (
      <ModalContainer
        isOpen={this.props.isOpen}
        size="md"
        onClose={this.props.sending ? undefined : this.props.onClose}
        footer={this.renderFooter()}
        header={this.renderHeader()}
        customstyleModalFooter="
          @media (max-width: 800px) {
            button {
              width: 121px;
              height: 33px;
              font-size: .88rem;
              background-color: #152b4e;
              padding: 0;
              margin: 0 9px;
            }
            .row {
              justify-content: center;
              padding: 0;
            }
          }
        "
      >
        <Container
          customstyle="
            text-align: center;
            margin: 20px auto;
            span { font-size: 12px; font-weight: 400 !important; }
            @media (max-width: 800px) { margin: 10px auto; }
          "
        >
          <GrayText>{this.renderBody()}</GrayText>
          {this.renderLoading()}
        </Container>
      </ModalContainer>
    );
  }
}

export default ModalReportWhatsapp;
